import React from "react";

export default class SubstanceIdentification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showInstructions: false, // Controls the visibility of the entire instructions section
      showVialText: false,     // Controls vial icon toggle
      showFlaskText: false,    // Controls flask icon toggle
      showMicroscopeLink: false, // Controls microscope icon toggle
    };
  }
  

  toggleVialText = () => {
    this.setState((prevState) => ({
      showVialText: !prevState.showVialText,
    }));
  };
  
  toggleFlaskText = () => {
    this.setState((prevState) => ({
      showFlaskText: !prevState.showFlaskText,
    }));
  };
  
  toggleMicroscopeLink = () => {
    this.setState((prevState) => ({
      showMicroscopeLink: !prevState.showMicroscopeLink,
    }));
  };
  

  // Function to determine the identification instructions based on name or class
  getIdentificationInstructions(substance) {
    const { name, classes } = substance;

    if (name.startsWith("2C-")) {
return [
        { icon: "fa-vial", text: "Use reagents Froehde, Liebermann, Marquis, Mecke, Robadope. For cuts use Liebermann, Marquis, Simon’s, Zimmermann, test strips and TLC." },
        { icon: "fa-flask", text: "Use test strips to rule out fentanyl, nitazens and xylazine." },
        { icon: "fa-microscope", text: "To estimate potency and detect all adulterants pair reagents with a TLC purity test kit." }
      ];
    }
    if (classes.includes("Amphetamine")) {
return [
        { icon: "fa-vial", text: "Use reagents Liebermann, Marquis, Robadope. For cuts use Froehde, Liebermann, Mecke, Simon’s, Zimmermann, test strips and TLC." },
        { icon: "fa-flask", text: "Use test strips to rule out fentanyl, nitazens and xylazine." },
        { icon: "fa-microscope", text: "To estimate potency and detect all adulterants pair reagents with a TLC purity test kit." }
      ];
    }
    if (classes.includes("Benzodiazepine")) {
return [
        { icon: "fa-vial", text: "Use reagent Zimmermann. For cuts use test strips." },
        { icon: "fa-flask", text: "Use test strips to rule out fentanyl, nitazens and xylazine." },
        { icon: "fa-microscope", text: "To estimate potency and detect all adulterants pair reagents with a TLC purity test kit." }
      ];
    }
    if (classes.includes("Cannabinoid")) {
return [
        { icon: "fa-vial", text: "Use reagents Cannabis (4-AP) and Zimmermann. For cuts use the same and TLC." },
        { icon: "fa-flask", text: "Use test strips to rule out fentanyl, nitazens and xylazine." },
        { icon: "fa-microscope", text: "To estimate potency and detect all adulterants pair reagents with a TLC purity test kit." }
      ];
    }
    if (name.includes("Cocaine")) {
return [
        { icon: "fa-vial", text: "Use reagents Liebermann and Morris. For cuts use Ehrlich, Froehde, Liebermann, Mecke, Robadope, Simon’s, Zimmermann, test strips and TLC." },
        { icon: "fa-flask", text: "Use test strips to rule out fentanyl, nitazens and xylazine." },
        { icon: "fa-microscope", text: "To estimate potency and detect all adulterants pair reagents with a TLC purity test kit." }
      ];
    }
    if (classes.includes("Substituted tryptamines")) {
return [
        { icon: "fa-vial", text: "Use reagents Ehrlich, Hofmann, Froehde, Liebermann, Marquis and Mecke. For cuts use test strips and TLC." },
        { icon: "fa-flask", text: "Use test strips to rule out fentanyl, nitazens and xylazine." },
        { icon: "fa-microscope", text: "To estimate potency and detect all adulterants pair reagents with a TLC purity test kit." }
      ];
    }
    if (classes.includes("Dissociatives")) {
return [
        { icon: "fa-vial", text: "Use reagents Liebermann and Morris. For cuts use Froehde, Liebermann, Marquis, Mecke, Robadope, Simon’s, Zimmermann, test strips and TLC." },
        { icon: "fa-flask", text: "Use test strips to rule out fentanyl, nitazens and xylazine." },
        { icon: "fa-microscope", text: "To estimate potency and detect all adulterants pair reagents with a TLC purity test kit." }
      ];
    }
    if (classes.includes("Lysergamides")) {
return [
        { icon: "fa-vial", text: "Use reagents Ehrlich and Hofmann. For cuts use Froehde, Liebermann, Marquis, Mecke and Robadope." },
        { icon: "fa-flask", text: "Use test strips to rule out fentanyl, nitazens and xylazine." },
        { icon: "fa-microscope", text: "To estimate potency and detect all adulterants pair reagents with a TLC purity test kit." }
      ];
    }
    if (classes.includes("MDxx")) {
return [
        { icon: "fa-vial", text: "Use reagents Froehde, Liebermann, Marquis and Simon’s. For cuts use Robadope, Zimmermann, test strips and TLC." },
        { icon: "fa-flask", text: "Use test strips to rule out fentanyl, nitazens and xylazine." },
        { icon: "fa-microscope", text: "To estimate potency and detect all adulterants pair reagents with a TLC purity test kit." }
      ];
    }
    if (classes.includes("Cathinone")) {
return [
        { icon: "fa-vial", text: "Use reagents Liebermann, Marquis, Simon’s and Zimmermann. For cuts use Froehde, Liebermann, Mecke, Robadope, fent strips and TLC." },
        { icon: "fa-flask", text: "Use test strips to rule out fentanyl, nitazens and xylazine." },
        { icon: "fa-microscope", text: "To estimate potency and detect all adulterants pair reagents with a TLC purity test kit." }
      ];
    }
    if (name.includes("methamphetamine") || (substance.aliases && substance.aliases.some(alias => alias.includes("methamphetamine")))) {
return [
        { icon: "fa-vial", text: "Use reagents Liebermann, Marquis, Mecke and Simon’s. For cuts use Froehde, Mecke, Robadope, Zimmermann, test strips and TLC." },
        { icon: "fa-flask", text: "Use test strips to rule out fentanyl, nitazens and xylazine." },
        { icon: "fa-microscope", text: "To estimate potency and detect all adulterants pair reagents with a TLC purity test kit." }
      ];
    }
    if (classes.includes("Opioid")) {
return [
        { icon: "fa-vial", text: "Use reagents Froehde, Liebermann, Marquis and Mecke. For cuts use test strips and TLC." },
        { icon: "fa-flask", text: "Use test strips to rule out fentanyl, nitazens and xylazine." },
        { icon: "fa-microscope", text: "To estimate potency and detect all adulterants pair reagents with a TLC purity test kit." }
      ];
    }
    const instructions = [];

    return instructions.length > 0 ? instructions : 
    [
      { icon: "fa-vial", text: "Use reagents tests to identify. For cuts use test strips and TLC." },
      { icon: "fa-flask", text: "Use test strips to rule out fentanyl, nitazens and xylazine." },
      { icon: "fa-microscope", text: "To estimate potency and detect all adulterants pair reagents with a TLC purity test kit." }
    ];
  }

  // Toggle the visibility of the entire instructions section
  toggleInstructions = () => {
    this.setState((prevState) => ({
      showInstructions: !prevState.showInstructions,
    }));
  };

  render() {
    const { substance } = this.props;
    const { showInstructions, showVialText, showFlaskText, showMicroscopeLink } = this.state;
  
    if (!substance) {
      return null;
    }
  
    const identificationInstructions = this.getIdentificationInstructions(substance);
  
    return (
      <div className="card" style={{ cursor: 'pointer', padding: '0px 20px 15px 20px', marginBottom: '30px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
        {/* Card Header with toggle functionality */}
        <div className="card-header" style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }} onClick={this.toggleInstructions}>
          <h2 style={{ cursor: 'pointer', margin: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 'calc(100% - 40px)' }}>
            How to test {substance.commonName}
          </h2>
          <i
            className={`zmdi ${showInstructions ? 'zmdi-chevron-up' : 'zmdi-chevron-down'}`}
            style={{ fontSize: '24px', verticalAlign: 'middle' }}
          ></i>
        </div>
  
        {/* Conditionally render the instructions section */}
        {showInstructions && (
          <div className="card-body" style={{ marginTop: '20px' }}>
            <table style={{ width: '100%', fontSize: '16px', lineHeight: '1.6', color: '#333' }}>
              <tbody>
                {identificationInstructions.map((guideline, index) => (
                  <tr key={index} style={{ marginBottom: '10px' }}>
                    <td style={{ width: '40px', verticalAlign: 'top', paddingTop: '20px', textAlign: 'center' }}>
                      <i className={`fa ${guideline.icon}`} style={{ fontSize: '24px'}}></i>
                    </td>
                    <td 
                      style={{ fontSize: 14, paddingTop: 10, paddingLeft: '10px', fontWeight: '500', color: '#555', cursor: 'pointer' }}
                      onClick={() => {
                        if (guideline.icon === "fa-vial") this.toggleVialText();
                        if (guideline.icon === "fa-flask") this.toggleFlaskText();
                      }}
                    >
                      {/* Always show the text from getIdentificationInstructions */}
                      {guideline.text}{" "}
                      {/* Show toggle for first two icons only */}
                      {guideline.icon !== "fa-microscope" && (
                        <span style={{ textDecoration: 'underline', color: 'inherit' }}>
                          {/* Show the appropriate toggle text */}
                          {(guideline.icon === "fa-vial" && showVialText) ||
                          (guideline.icon === "fa-flask" && showFlaskText)
                            ? "Click here to hide details"
                            : "Click here for more details"}
                        </span>
                      )}
                      
                      {/* Conditionally render additional text or link */}
                      {guideline.icon === "fa-vial" && showVialText && (
                        <div style={{ marginTop: '5px' }}>
                          <br></br>Reagent tests are simple chemicals that change color on contact with a substance, allowing for identification. You can purchase them from PRO Test website.<br></br>
                          
                          <br></br><strong>GET ALL TOOLS</strong><br/>
                          First, prepare a clean white testing surface - ceramic or glass is the best. Get your sample, reagent(s), a clean spatula or toothpick and cleaning wipes.<br/><br/>
                          
                          <strong>PREPARE SAMPLE, ABOUT THIS BIG ⚫️</strong><br/>
                          If testing a pill, powder or crystal, crush it finely. If testing a liquid, dry one drop on paper or clean ceramic surface. If testing a blotter or gel tab cut off at least 1/8th (a corner). A bigger sample can cause a stronger reaction. You need a new sample for each test.<br/><br/>
  
                          <strong>ADD ONE DROP (OR PILE) OF REAGENT</strong><br/>
                          Shake the glass bottle hard before use. Do not let the bottle touch your sample, or you will ruin the rest of the reagent. Use just enough reagent to cover the sample. If using crystalline reagent, flatten it on top of the sample. Do not mix reagents except for "A" and "B" bottles. If using Morris reagent, mix with a clean spatula/toothpick for 30 seconds.<br/><br/>
  
                          <strong>HANDLING CRYSTALLINE REAGENTS IN GLASS BOTTLES</strong><br/>
                          1. Right before use, shake the reagent bottle very hard for 5-10 seconds.<br/>
                          2. Wearing gloves, tap the bottle against your hand to shake down reagent crystals from the bottle cap.<br/>
                          3. To add crystalline reagent to the sample, pour out the reagent by tapping the bottle label or use a clean spatula.<br/>
                          4. It is recommended to flatten the crystalline reagent on top of the sample to increase reaction intensity.<br/>
                          5. Wipe the clean bottle cap and neck to avoid "crunchy lid syndrome" and protect the reagent from air.<br/>
  
                          <br></br><strong>OBSERVE FOR UP TO 2 MINUTES*</strong><br/>
                          Disregard any significant color change after 1-2 minutes. Fumes are normal. Take photos. *If testing LSD using Ehrlich or Hofmann, observe the reaction for up to 60 minutes.<br/><br/>
  
                          <strong>COMPARE RESULTS</strong><br/>
                          Compare color change with instructions, protestkit.eu/videos, protestkit.eu/photos or within the DrugsPRO app. Reagents can indicate PRESENCE, but not PURITY or QUANTITY. Adulterants can be detected with reagents only if they cause a darker reaction than the expected substance. To discover the number and amount of all ingredients, pair reagents with a TLC purity test kit.<br/><br/>
                        <br></br></div>
                      )}
                      {guideline.icon === "fa-flask" && showFlaskText && (
                        <div style={{ marginTop: '5px' }}>
                          <br></br>Test strips are simple tools that help check presence of even trace amount of specific adulterants. You can get them from PRO Test website.<br></br>
                          
                          <br></br>
                          <strong>If testing a pill:</strong><br/>
                          Crush one in a plastic baggie and dump out the powder. Then add ten drops of water into the baggie and mix well. Dip the test strip no higher than the thick line. Wait 15 seconds. Put the strip away and check in 5 minutes. 1 line = fentanyl, 2 lines = no fentanyl. Faint lines also count.<br/><br/>
                          
                          <strong>If testing powder:</strong><br/>
                          Dissolve 100 mg of a sample in 200 ml of water. Dip the test strip no higher than the thick line. Wait 15 seconds. Put the strip away and check in 5 minutes. 1 line = fentanyl, 2 lines = no fentanyl.<br/>
                        <br></br></div>
                      )}
                      {/* For fa-microscope, display the link directly in normal color and inline */}
                      {guideline.icon === "fa-microscope" && (
                        <span style={{ textDecoration: 'underline', color: 'inherit' }}>
                          <a href="https://protestkit.eu/tlcbooklet.pdf" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'underline' }}>
                            Click here to open TLC booklet
                          </a>
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  }
  
  
}
